import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatSerbiaTime = (date) => {
  if (!date) return null;

  return dayjs(date)
    .tz("Europe/Belgrade")
    .format("YYYY-MM-DDTHH:mm:ss");
};


//  return date.tz("Europe/Belgrade").format("YYYY-MM-DDTHH:mm:ss"); pre kako je bilo 
